import en from './en.json';

const messages = {
  en,
};

export default messages;
